import { useLocation } from 'react-router-dom';
import { useSessionContext } from 'contexts/sessionProvider/SessionProvider';
import {
  FLOW_STEPS,
  STEP_PATH, SUBSCRIPTION_TYPE
} from '../../constants';

export const useGetNextPageUrl = (currentStep: string, isNewUser?: boolean) => {
  const { subscriptionType, region, activationCode, promoCode, useLegacy , isAnnualRoute } = useSessionContext();
  const { search } = useLocation();

  switch (currentStep) {
    case FLOW_STEPS.EMAIL: {
      const params = new URLSearchParams(search);
      if (!activationCode && promoCode) {
        params.set('pc', promoCode);
      }
      params.set('use-legacy', useLegacy ? 'true' : 'false');
      if (isAnnualRoute) {
        params.set('use-annual', 'true');
      }
      const queryString = `?${params.toString()}`;
      switch (subscriptionType) {
        case SUBSCRIPTION_TYPE.TRIAL:
          return `/${region.toLowerCase()}${STEP_PATH.TRIAL.ACCOUNT}${queryString}`;
        case SUBSCRIPTION_TYPE.QUOTE:
          return `${STEP_PATH.QUOTE.ACCOUNT}${queryString}`;
        default:
          return `/${region.toLowerCase()}${STEP_PATH.SUBSCRIBE.ACCOUNT}${queryString}`;
      }
    }
    case FLOW_STEPS.ACCOUNT_SETUP: {
      switch (subscriptionType) {
        case SUBSCRIPTION_TYPE.TRIAL: {
          if (isNewUser) {
            return `/${region.toLowerCase()}${STEP_PATH.TRIAL.CONFIRMATION}`;
          }
          return `/${region.toLowerCase()}${STEP_PATH.TRIAL.DUPLICATE}`;
        }
        case SUBSCRIPTION_TYPE.QUOTE:
          return `${STEP_PATH.QUOTE.PAYMENT}`;
        default:
          return `/${region.toLowerCase()}${STEP_PATH.SUBSCRIBE.PAYMENT}`;
      }
    }
    case FLOW_STEPS.PAYMENT: default: {
      switch (subscriptionType) {
        case SUBSCRIPTION_TYPE.QUOTE:
          return `${STEP_PATH.QUOTE.CONFIRMATION}`;
        default:
          return `/${region.toLowerCase()}${STEP_PATH.SUBSCRIBE.CONFIRMATION}`;
      }
    }
  }
};
